<template>
  <div
    class="notice__content el-row"
    @mouseleave="onMouseLeave"
    @mouseenter="onMouseEnter"
  >
    <el-col :span="noticeInit.col1">
      <slot name="noticeLabel"></slot>
    </el-col>
    <el-col :span="noticeInit.col2">
      <el-row>
        <el-col :span="showBtn ? 23 : 24">
          <marquee
            v-show="scrolling"
            @mouseover="onMouseOver"
            @mouseout="onMouseOut"
            :style="`color: ${noticeInit.color}`"
            class="notice__scroll"
            ref="marquee"
            id="marquee"
            >{{ currentNoticeContent }}</marquee
          >
          <p
            v-show="!scrolling"
            class="notice__scroll_more"
            id="scrollMore"
            ref="scrollMore"
          >
            {{ currentNoticeContent }}
          </p>
        </el-col>
        <el-col :span="showBtn ? 1 : 0" class="tr"
          ><span
            :class="['notice__arrow', !scrolling && 'notice__arrow_active']"
            @click="onStartMaqueeFun"
          ></span
        ></el-col>
      </el-row>
    </el-col>
    <el-col :span="noticeInit.col3" v-if="noticeInit.col3">
      <slot name="noticeClose"></slot>
    </el-col>
  </div>
</template>

<script>
// import { unionFlag } from "../../utils";
export default {
  props: {
    noticeData: {
      type: Object,
      default: () => null
    },
    unionHead: {
      type: Object,
      default: () => null
    },
    noticeInit: Object
  },
  data() {
    return {
      timer: null,
      step: 0,
      noticeCont: null,
      noticeElem: null,
      scrolling: false,
      showBtn: false,
      endY: 0,
      $dom: null,
      $maq: null
    };
  },
  computed: {
    currentNoticeContent() {
      const { noticeContent } = this.noticeData;

      if (this.unionHead) {
        const { mallUnionConfigDto } = this.unionHead;

        if (mallUnionConfigDto) {
          const {
            openNotice,
            isShowUnionNotice,
            unionNoticeContent
          } = mallUnionConfigDto;

          if (openNotice) {
            if (isShowUnionNotice) {
              return noticeContent + unionNoticeContent;
            } else {
              return noticeContent;
            }
          } else {
            if (isShowUnionNotice) {
              return unionNoticeContent;
            }
          }
        }
      }

      return noticeContent;
    }
  },
  mounted() {
    this.$nextTick(() => {
      try {
        // const isUnion = unionFlag();
        const { hostname } = window.location;
        this.$dom = this.$refs.scrollMore;
        this.$maq = this.$refs.marquee;
        // if (isUnion) {
        //   this.scrolling = true;
        //   return;
        // }
        anime.set(this.$dom, { visibility: "hidden" });
        this.endY = anime.get(this.$dom, "height");
        anime.set(this.$dom, { visibility: "" });
        this.showBtn = parseInt(this.endY) > 20;
        if (this.showBtn) {
          if (!this.publicMethod.getCookie("dffl_notice_pc_isExist")) {
            this.publicMethod.setCookie(
              "dffl_notice_pc_isExist",
              true,
              604800,
              "/",
              `.${hostname}`
            );
            anime({
              targets: this.$dom,
              height: this.endY,
              begin: () => {
                anime.set(this.$maq, { display: "none" });
                anime.set(this.$dom, { display: "-webkit-box" });
              }
            });
          } else {
            this.scrolling = !this.scrolling;
          }
        } else {
          this.scrolling = !this.scrolling;
        }
      } catch (error) {
        console.log(error);
      }
    });
  },
  methods: {
    onStartMaqueeFun(ev) {
      try {
        ev.stopPropagation();
        if (this.scrolling) {
          this.$maq.stop();
          this.scrolling = !this.scrolling;
          anime({
            targets: this.$dom,
            height: this.endY
          });
        } else {
          anime.set(this.$dom, { height: 0 });
          this.scrolling = !this.scrolling;
          this.$maq.start();
        }
      } catch (error) {
        console.log(error);
      }
    },
    onMouseOver(ev) {
      try {
        ev.stopPropagation();
        this.$maq.stop();
        if (this.showBtn) {
          this.scrolling = !this.scrolling;
          anime({
            targets: this.$dom,
            height: this.endY
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    onMouseOut(ev) {
      try {
        if (!this.showBtn) {
          ev.stopPropagation();
          this.$maq.start();
        }
      } catch (error) {
        console.log(error);
      }
    },
    onMouseLeave(ev) {
      try {
        ev.stopPropagation();
        if (!this.scrolling) {
          this.timer = setTimeout(() => {
            this.scrolling = !this.scrolling;
            anime.set(this.$dom, { height: 0 });
            anime.set(this.$maq, { display: "block" });
            this.$maq.start();
          }, 1000);
        }
      } catch (error) {
        console.log(error);
      }
    },
    onMouseEnter(ev) {
      ev.stopPropagation();
      clearTimeout(this.timer);
    }
  }
};
</script>

<style lang="less" scoped>
.notice {
  &__scroll {
    vertical-align: top;
    &_more {
      color: #3d96e2;
      .line-clamp(4);
    }
  }
  &__arrow {
    position: relative;
    display: inline-block;
    background: url("./imgs/arrow@2x.png") no-repeat;
    background-size: cover;
    width: 12px;
    height: 12px;
    transition: transform 0.3s;
    &_active {
      transform: rotate(180deg);
    }
  }
}
</style>
